import axios from 'axios';
import { fetchAuthSession, signOut } from 'aws-amplify/auth';
import { store } from '../store';
import { signOutSuccess } from '../store/slices/authSlice';
import { clearUser } from '../store/slices/userSlice';
import { API_CONFIG } from '../config';
import { TOKEN_TYPE, REQUEST_HEADER_AUTH_KEY } from '../constants/api.constant';

const unauthorizedCode = [401];

const BaseService = axios.create({
    timeout: 60000,
    baseURL: API_CONFIG.baseUrl,
});

BaseService.interceptors.request.use(
    async (config) => {
        try {
            const session = await fetchAuthSession();
            const accessToken = session.tokens?.accessToken?.toString();

            if (accessToken) {
                config.headers[REQUEST_HEADER_AUTH_KEY] = `${TOKEN_TYPE}${accessToken}`;
            }
        } catch (error) {
            console.error('Failed to fetch auth session:', error);
        }

        config.headers['Content-Type'] = 'application/json';

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

BaseService.interceptors.response.use(
    (response) => response,
    (error) => {
        const { response } = error;

        if (response && unauthorizedCode.includes(response.status)) {
            signOut().then();
            store.dispatch(signOutSuccess());
            store.dispatch(clearUser());
        }

        return Promise.reject(error);
    }
);

export default BaseService;
